
class CurtainTypeSelector extends HTMLElement {
  constructor() {
    super();

    this.curtainUrl = this.dataset.productUrl;
    this.curtainType = null;
    this.curtainHeightOptions = null;
    this.selectedHeight = null;
    this.selectedOptId = null;
    this.qtyBoxInp = this.querySelector('#qty-value'); 
    this.qty = Number(this.qtyBoxInp.dataset.qtyValue);
    this.priceEl = this.querySelector('.buy-btn__price');
    this.buyInfo = this.querySelector('.buy-btn__info');
    this.basePrice = this.priceEl.dataset.basePrice;
    // this.chatEl = document.querySelector('.request-chat'); 
    this.btnHeaderInfo = this.querySelector('.product-card-header');
    this.selectedHeightEl = document.querySelector('.product-card-header-sqft'); 
    this.btnHeightEl = document.querySelector('.buy-btn__value'); 
    this.addToCartBtn = this.querySelector('curtain-type-selector #buy-btn');
    this.heightInput = this.querySelector('input[name="height"]');
    this.quantityInput = this.querySelector('input[name="quantity"]');
    this.variantId = this.addToCartBtn.dataset.variantId;
    this.errorMessage = this.querySelector(".error-message");
    this.warning = this.querySelector(".product-warning");
  }

  connectedCallback() {
    const infoEl = this.querySelector('.buy-btn__info');
    if (!infoEl) return;

    this.basePrice = Number(infoEl.dataset.basePrice);
   
    this.debouncedFetchVariantId = debounce(this.fetchVariantId.bind(this),500);

    const selectedCurtainTypeEl = document.querySelector('.product__type-box.selected');
    this.curtainType = selectedCurtainTypeEl?.dataset.productType;
    
   
    const curtainHeightOptionsSelector = this.querySelector('[data-height-variants]');
    if (!curtainHeightOptionsSelector) return;

    this.curtainHeightOptions = JSON.parse(curtainHeightOptionsSelector.textContent);

    if(this.curtainType === 'Stitched' && this.heightInput) {
      this.getHeight();

      this.heightInput.addEventListener('input', () => {
        this.getHeight();
      });
    }

    if(this.curtainType === 'By the Meter' && this.quantityInput) {
      this.isDisableBtn(this.quantityInput);
      
      this.quantityInput.addEventListener('input', () => {
        this.isDisableBtn(this.quantityInput);
        this.priceUpdate();      
      });
      
      // For "By the Meter", fetch initial variant ID based on selected color/material
      if (this.debouncedFetchVariantId) {
        this.debouncedFetchVariantId();
      }
    }

    this.querySelector('#qty-increase')?.addEventListener('click', () => {
      console.log('this.variantId',this.qty)
      this.qty++;
      this.updateQty();
    });

    this.querySelector('#qty-decrease')?.addEventListener('click', () => {
        console.log('this.variantId',this.qty)
      if (this.qty > 1) {
        this.qty--;
        this.updateQty();
      }
    });

    this.addToCartBtn?.addEventListener('click', () => {
      this.addToCart();
    });

    // Listen for variant changes to update variant ID when color/material changes
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      // For "Stitched" type: update variant ID if height is already selected
      // For "By the Meter" type: always update variant ID when color/material changes
      if (this.curtainType === 'Stitched') {
        if (this.selectedOptId && this.debouncedFetchVariantId) {
          this.debouncedFetchVariantId();
        }
      } else if (this.curtainType === 'By the Meter') {
        // For "By the Meter", update variant ID immediately when color changes
        if (this.debouncedFetchVariantId) {
          this.debouncedFetchVariantId();
        }
      }
    });

  }
  
  isDisableBtn(el){
    const qtyValue = Number(el.value);
    this.qty  = qtyValue;
    if (!qtyValue || qtyValue <= 0) {
        this.disbleAddtoCart(true);
        return;
      }
    this.btnHeightEl.textContent =
    this.qty === 1 ? `${this.qty} meter` : `${this.qty} meters`;
    this.disbleAddtoCart(false);
  }


  getAllSelectedOptionValues() {
    // Get all currently selected option values from variant picker (color, material, etc.)
    const variantSelects = document.querySelector('product-variant-selects');
    if (!variantSelects) return [];
    
    // Use the same method as ProductVariantSelects to get selected option values
    const selectedOptions = Array.from(
      variantSelects.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId).filter(Boolean);
    
    return selectedOptions;
  }

  async fetchVariantId() {
    const sectionId = 'data-selected-variant';
    
    // For "Stitched" type, height is required
    if (this.curtainType === 'Stitched') {
      const height = this.heightInput?.value;
      if (!height) return;
    }

    // Get all currently selected option values (color, material, etc.) from DOM
    const allSelectedOptions = this.getAllSelectedOptionValues();
    
    // Build the option values array: include all selected options + height option (if Stitched type)
    const optionValues = [...allSelectedOptions];
    if (this.curtainType === 'Stitched' && this.selectedOptId) {
      optionValues.push(this.selectedOptId);
    }

    // For "By the Meter" type, we need at least color/material options
    if (this.curtainType === 'By the Meter' && optionValues.length === 0) {
      return;
    }

    console.log('optionValues', optionValues);
    const url = `${this.curtainUrl}?section_id=${sectionId}&option_values=${optionValues.join(",")}`;
    try {
      const response = await fetch(url);
      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const data = JSON.parse(html.querySelector("[selected-variant]")?.textContent || "{}");
      this.updateGlobalVariant(data.id);
      this.variantId = data.id;
      this.basePrice = (data.price || 0) / 100;
      this.priceUpdate();
    } catch (err) {
      console.error('Variant fetch failed:', err);
    }
  }

   priceUpdate(){
    console.log('inputValue',this.qty)
    console.log('basePrice',this.basePrice)
    const total = this.basePrice * this.qty;

    this.priceEl.innerHTML = `$${total.toLocaleString(
      "en-IN"
    )}`;  
  }

  updateQty() {
    if (this.qtyBoxInp) {
      this.qtyBoxInp.textContent = this.qty;
      this.priceUpdate();
      // Only call getHeight for "Stitched" type
      if (this.curtainType === 'Stitched') {
        this.getHeight();
      }
    }
  }

  // showRequestChat(show) {
  //   if (!this.chatEl) return;
  //   this.chatEl.style.display = show ? 'flex' : 'none';
  // }

  showError(state,msg){
    if (!this.errorMessage) return;
    const errorTextEl = this.errorMessage.querySelector('.product_error-message');
    errorTextEl.textContent = msg;
    this.errorMessage.style.display = state ? 'flex' : 'none';
  }
  

  disbleAddtoCart(state){
    if(state == true){
       this.buyInfo.style.display ="none";
       this.addToCartBtn.setAttribute("disabled", true);
       if (this.btnHeaderInfo) this.btnHeaderInfo.style.display ="none";
    }else{
       this.buyInfo.style.display ="flex";
       this.addToCartBtn.removeAttribute("disabled");
       if (this.btnHeaderInfo) this.btnHeaderInfo.style.display ="block";
    }
  }


  getHeight() {
    if (!this.heightInput || !this.curtainHeightOptions) return;

    const height = parseInt(this.heightInput.value, 10);
    if (!height){
       this.disbleAddtoCart(true);
       this.warning.style.display = "none";
       return;
    };

     this.disbleAddtoCart(false);
    
    const curtainHeights = Object.keys(this.curtainHeightOptions)
      .map(h => parseInt(h, 10))
      .filter(Boolean)
      .sort((a, b) => a - b);

    const min = curtainHeights[0];
    const max = curtainHeights[curtainHeights.length - 1];

    const isTooLarge = height > max;
    
    if (isTooLarge) {
      this.msg = `Height is too large. Maximum ${max} Height exceeded`;

      // this.showRequestChat(true);
      this.showError(true,this.msg);
      this.disbleAddtoCart(true);
      return;
    }

    if(height < min && height > 0){
      this.warning.style.display = "block";
    }else{
      this.warning.style.display = "none";
    }
 
    this.showError(false, this.msg ='');
    // this.showRequestChat(false);
    this.disbleAddtoCart(false);

    this.selectedHeight = height < min ? min : height;
    if (this.selectedHeightEl) this.selectedHeightEl.textContent =`${this.selectedHeight} inches`;
    this.btnHeightEl.textContent = `${this.selectedHeight} in x ${this.qty}`;
    this.selectedOptId = this.curtainHeightOptions[this.selectedHeight];

    if (this.selectedOptId && this.debouncedFetchVariantId) {
      this.debouncedFetchVariantId();
    }
  }

  async addToCart() {
    const height = this.heightInput?.value;
    const quantity = Number(this.quantityInput?.value || this.qty);

    if (!this.variantId) return;
    if (this.curtainType === 'Stitched' && !height) return;
    if (!quantity || quantity <= 0) return;

    // Build cart item - only include properties for "Stitched" type
    const cartItem = {
      id: this.variantId,
      quantity: this.qty,
    };
    
    // Only add Height property for "Stitched" type
    if (this.curtainType === 'Stitched' && this.selectedHeight) {
      cartItem.properties = {
        Height: this.selectedHeight,
      };
    }

    const body = JSON.stringify({
      items: [cartItem],
      sections: ["cart-drawer"],
    });

    try {
      this.addToCartBtn.classList.add("is-loading");
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body,
        }
      );
      const data = await response.json();
      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "type selector",
        productVariantId: this.variantId,
        cartData: data,
      });

      setTimeout(() => {
        if (cart?.renderContents) cart.renderContents(data);
      }, 200);
    } catch (err) {
      console.error("Cart add failed:", err);
    } finally {
      this.addToCartBtn.classList.remove("is-loading");
    }
  }


  updateGlobalVariant(matchId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', matchId);
    window.history.replaceState({}, '', url.toString());

    const variantIdContainer = document.querySelector('.product-variant-id');
    if (!variantIdContainer) return;
    
    variantIdContainer.value = matchId;
  }
}

customElements.define('curtain-type-selector', CurtainTypeSelector);
